import React from "react";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { baseURL } from "../../Config/config";

const MathModal = (props) => {
  const navigate = useNavigate();

  const [projectName, setProjectName] = React.useState("");
  const [clientname, setClientName] = React.useState("");
  const [objective, setObjective] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  // const createNewProject = async () => {
  //   navigate("/newproject");
  // }
  const createNewMathProject = async () => {
    const projectID = uuidv4(); // ⇨ '9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d'
    setIsLoading(true);
    const body = {
      projectName,
      clientname,
      objective,
      time: new Date(),
      // projectID,
      de : []
    };
    sessionStorage.setItem("projectName", projectName);
    sessionStorage.setItem("projectID", projectID);
    sessionStorage.setItem("loaded", false);
   const token =  sessionStorage.getItem("usertoken");

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json","token":token },
      body: JSON.stringify(body), 
    };
    try {
      let res = await fetch(`${baseURL}/newmathproject`, requestOptions);
      res = await res.json();
      if (res.code) {
        sessionStorage.setItem("projectID",res.message)
        setIsLoading(false);
        navigate("/newmathproject", { state: { loaded: false, ProjectID: false } });
        return;
      }
      alert("Some Error");
      setIsLoading(false);
    } catch (error) {
      alert("Some Error", error);
      setIsLoading(false);
      console.log("err", error);
    }
  };

 return (
  <Modal
    open={props.isModal}
    onClose={props.toggleModal}
    aria-labelledby="modal-modal-title"
  >
    <Box
      sx={{
        width: 380,
        bgcolor: "#fff",
        borderRadius: "22px",
        p: 3,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        boxShadow: "0px 12px 40px rgba(0,0,0,.15)",
        border: "1px solid #d9e9f7",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 700,
          color: "#0078c9",
          mb: 0.5,
        }}
      >
        Create New Math Project
      </Typography>

      <Typography sx={{ fontSize: "12px", color: "#666", mb: 2 }}>
        Enter basic math project details.
      </Typography>

      {[
        {
          label: "Project Name",
          onChange: (e) => setProjectName(e.target.value),
          required: true,
        },
        {
          label: "Client Name",
          onChange: (e) => setClientName(e.target.value),
        },
        {
          label: "Objective",
          onChange: (e) => setObjective(e.target.value),
        },
      ].map((field, i) => (
        <Box key={i} sx={{ mb: 1.6 }}>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 600,
              color: "#444",
              mb: 0.6,
            }}
          >
            {field.label} {field.required ? "" : "(Optional)"}
          </Typography>

          <TextField
            fullWidth
            size="small"
            variant="outlined"
            placeholder=""
            onChange={field.onChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                fontSize: "14px",
                height: 40,
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#d9e9f7",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#9e0b22",
              },
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0078c9",
              },
            }}
          />
        </Box>
      ))}

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        {isLoading ? (
          <CircularProgress size={28} sx={{ color: "#0078c9" }} />
        ) : (
          <Button
            disabled={!projectName}
            onClick={createNewMathProject}
            variant="contained"
            sx={{
              height: 40,
              px: 3,
              fontSize: "12px",
              fontWeight: 600,
              borderRadius: "12px",
              textTransform: "none",
              background: "linear-gradient(90deg,#0078c9,#0d8fe6)",
              boxShadow: "0px 8px 18px rgba(0,120,201,.25)",

              "&:hover": {
                background: "#9e0b22",
              },
            }}
          >
            Continue
          </Button>
        )}
      </Box>
    </Box>
  </Modal>
);
};

export default MathModal;
